<div class="bm-help">
  <span>Нужна помощь?</span>
  <span>Напишите нам через форму "спасательного круга"</span>
  <span><img src="static/icons/rescuing_range.png" alt=""></span>
</div>
